<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/energy-usage">エネルギーの利用状況</router-link></li>
        </ul>
      </div>
    </div>
    <div class="energy energy--block">
      <div class="container">
        <div class="energy-content">
          <h2>ENVIRONMENT<span>環境</span></h2>
          <div id="energy1">
            <EnergyMenu :energyMenuChild="energyMenu" />
          </div>
        </div>
      </div>
      <div class="energy-cont">
        <div class="container">
          <div class="cont-child">
            <div class="cont-child__list">
              <EnergyItem1 />
              <EnergyItem2 />
              <EnergyItem3 />
            </div>
            <!-- <div class="wrap-img">
              <img
                src="@/assets/img/energy/energy-cont-01.jpg"
                alt="energy-cont-01"
              />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { radioButton } from "@/assets/js/radio-button";
import CONSTANT from "@/constant";
import { metaData } from '@/utils/helper';

export default {
  name: "EnergyUsage",
  components: {
    EnergyMenu: () => import("@/components/common/EnergyMenu.vue"),
    EnergyItem1: () =>
      import("@/components/common/energy/area/EnergyItem1.vue"),
    EnergyItem2: () =>
      import("@/components/common/energy/area/EnergyItem2.vue"),
    EnergyItem3: () =>
      import("@/components/common/energy/area/EnergyItem3.vue"),
  },
  data() {
    return {
      energyMenu: CONSTANT.dataEnergyMenu
    };
  },
  created() {
    metaData(
        `エネルギーの利用状況 | HARUMIFLAGタウンポータル`,
        '中央区晴海・HARUMIFLAGのエネルギーの利用状況のご紹介ページです。',
        'HARUMIFLAGタウンポータル',
        'article'
      )
  },
  computed: {},
  mounted() {
    radioButton();
  },
};
</script>